// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const InsuranceComHOService = {};

InsuranceComHOService.getInsuranceComHO = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/InsuranceComHO/search?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&description=" +
      data?.description,
    method: "get",
  });
};

InsuranceComHOService.getInsuranceComBranch = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/InsuranceComBranch/search?pageSize=" +
      1000 +
      "&pageIndex=" +
      decrementIndex +
      "&maskAssBranchId=" +
      data?.maskAssBranchId +
      "&maskAssId=" +
      data?.maskAssId +
      "&maskAssBranchName=" +
      data?.maskAssBranchName,

    method: "get",
  });
};

InsuranceComHOService.GetApkLoanInsuranceKTA = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanInsuranceKTA/get?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};

InsuranceComHOService.GetApkLoanInsuranceKTACalculate = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanInsuranceKTA/calculate?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&applicationid=" +
      data?.applicationid +
      "&maskassid=" +
      data?.maskassid +
      "&maskassbranchid=" +
      data?.maskassbranchid,
    method: "get",
  });
};

InsuranceComHOService.GetKonsumendariProspect = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/konsumendariProspect/konsumenprospect?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};

InsuranceComHOService.postApkLoanInsuranceKTA = function (data) {
  // console.log("🚀 ~ datapostApkLoanInsuranceKTA", data);

  return lossClient({
    url: `/ApkLoanInsuranceKTA/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

InsuranceComHOService.putApkLoanInsuranceKTA = function (data) {
  // console.log("🚀 ~ datapostApkLoanInsuranceKTA", data);

  return lossClient({
    url: `/ApkLoanInsuranceKTA/edit`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data.data,
  });
};
InsuranceComHOService.deleteApkLoanInsuranceKTA = function (data) {
  // console.log("🚀 ~ datapostApkLoanInsuranceKTA", data);

  return lossClient({
    url: `/ApkLoanInsuranceKTA/delete`,
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: data.data,
  });
};

export default InsuranceComHOService;
